

















































































































































































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import { filter, maxBy } from 'lodash'
import { ProcessLog } from '@/store/workflow/types'
import AuthorizationMixin from '@/routing/AuthorizationMixin'

import Process from '@/components/workflow/Process.vue'
import Timer from '@/components/workflow/Timer.tsx'
import Task from '@/components/workflow/Task.tsx'
import Gateway from '@/components/workflow/Gateway.tsx'

import iptLandingWidget from '@/views/treatment/depression/ipt/LandingWidget.vue'
import counselingLandingWidget from '@/views/counseling/LandingWidget.vue'
import cbtLandingWidget from '@/views/treatment/depression/cbt/LandingWidget.vue'
import expoLandingWidget from '@/views/treatment/ptsd/expo/LandingWidgetsNew.vue'
import crLandingWidget from '@/views/treatment/ptsd/cr/LandingWidgetsNew.vue'
import assessmentLandingWidget from '@/views/assessments/LandingWidget.vue'
import interviewLandingWidget from '@/views/interview-booking/LandingWidget.vue'

export default mixins(AuthorizationMixin).extend({
  components: {
    assessmentLandingWidget,
    cbtLandingWidget,
    crLandingWidget,
    expoLandingWidget,
    Gateway,
    interviewLandingWidget,
    counselingLandingWidget,
    iptLandingWidget,
    Process,
    Task,
    Timer,
  },
})
